function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#ccc",
  d: "M19.559 3.3a.7.7 0 0 0-.647-.344h-6.018a.711.711 0 0 0-.652.344 13.686 13.686 0 0 0-1.555 4.665v.179a3.032 3.032 0 0 0 1.424 2.785 12.167 12.167 0 0 0 1.128.729c.958.572 1.946 1.163 1.946 1.877v4.3c0 .041-.045.075-.1.075h-2.863c-.4 0-.717.236-.717.523s.321.523.717.523h7.362c.4 0 .717-.236.717-.523s-.321-.523-.717-.523h-2.863c-.055 0-.1-.034-.1-.075v-4.3c0-.714.988-1.3 1.946-1.877a12.877 12.877 0 0 0 1.128-.729 3.032 3.032 0 0 0 1.424-2.785v-.182a13.636 13.636 0 0 0-1.56-4.662zm-.07 3.817a.107.107 0 0 1-.08.026H12.4a.157.157 0 0 1-.08-.026.061.061 0 0 1-.02-.064 22.57 22.57 0 0 1 1.083-3 .11.11 0 0 1 .1-.052h4.847a.1.1 0 0 1 .1.052 24.3 24.3 0 0 1 1.083 3 .064.064 0 0 1-.024.061z",
  transform: "translate(-10.688 -2.953)"
});

var SvgIconBeverage = function SvgIconBeverage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10.431,
    height: 16,
    viewBox: "0 0 10.431 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconBeverage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_beverage.c8774f98.svg";
export { ForwardRef as ReactComponent };